import { useEffect, useState } from 'react';
import type { StreamEvent } from '@pacer/shared';
import { invalidateFor } from './queries';

const STREAM_EVENTS: StreamEvent[] = [
  'events:changed',
  'members:changed',
  'lists:changed',
  'chores:changed',
  'feeds:changed',
  'photos:changed',
  'household:changed',
];

/**
 * Holds the live channel open and turns every server push into a cache invalidation.
 *
 * EventSource reconnects on its own (honouring the server's `retry:`), so there's no
 * backoff logic here — we only surface connection state for the status dot.
 */
export function useSSE(enabled: boolean): { connected: boolean } {
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    const es = new EventSource('/api/stream', { withCredentials: true });

    es.onopen = () => setConnected(true);
    es.onerror = () => setConnected(false);

    for (const name of STREAM_EVENTS) {
      es.addEventListener(name, () => invalidateFor(name));
    }

    return () => {
      es.close();
      setConnected(false);
    };
  }, [enabled]);

  return { connected };
}
